const SpecificGravity = ["1.005", "1.010", "1.015", "1.020", "1.025", "1.030"];

export default SpecificGravity;
